import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_035.jpg';
page.images = [
  {
    imageId: 'page035_zoom0',
    rectangle: {
      x: 606,
      y: 1572,
      width: 1176,
      height: 710,
    },
    imageSrc: 'images/page035/035 3.jpg',
  },
  {
    imageId: 'page035_zoom1',
    rectangle: {
      x: 606,
      y: 840,
      width: 1178,
      height: 722,
    },
    imageSrc: 'images/page035/035 2.jpg',
  },
  {
    imageId: 'page035_zoom2',
    rectangle: {
      x: 602,
      y: 114 + 170,
      width: 1180,
      height: 722 - 170,
    },
    imageSrc: 'images/page035/035 1.jpg',
  },
];
page.games = [
  {
    id: 'page035_game12',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1554,
    },
    item: {
      id: 'page035_game12',
    },
    rectangle: {
      id: 'page035_rect2',
    },
  },
  {
    id: 'page035_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 818,
    },
    item: {
      id: 'page035_game11',
    },
    rectangle: {
      id: 'page035_rect1',
    },
  },
  {
    id: 'page035_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 90,
    },
    item: {
      id: 'page035_game10',
    },
    rectangle: {
      id: 'page035_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page035_rect0',

    tooltip: '',

    linked: ['page035_game10'],
    x: 121,
    y: 90,
    width: 443,
    height: 647,
  },
  {
    id: 'page035_rect1',

    tooltip: '',

    linked: ['page035_game11'],
    x: 119,
    y: 818,
    width: 453,
    height: 395,
  },
  {
    id: 'page035_rect2',

    tooltip: '',

    linked: ['page035_game12'],
    x: 117,
    y: 1554,
    width: 455,
    height: 635,
  },
];
export default page;
